import { format, isBefore } from 'date-fns'
import { isEqual } from 'lodash'

/**
 * Compare date with a mock date
 * @param {string} dateStr
 * @param {string} mockDateStr
 * @returns boolean
 */
export const isBeforeOrEqualMock = (dateStr, mockDateStr) => {
  if (dateStr) {
    const date = new Date(dateStr)
    const compareDate = new Date(format(date, 'yyyy-MM-dd'))
    const mockDate = new Date(mockDateStr)
    const isBeforeMock = isBefore(compareDate, mockDate)
    const isEqualMock = isEqual(compareDate, mockDate)

    return isBeforeMock || isEqualMock
  }

  return false
}
